import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MaterialModule } from './material/material.module';
import { ReactiveFormsModule } from '@angular/forms';
import { ChartComponent } from './components/chart/chart.component';
import { TableComponent } from './components/table/table.component';
import { PaginatorComponent } from './components/paginator/paginator.component';
import { CustomDatePipe } from './Utils/pipeCustomDate';
import { TranslateModule } from '@ngx-translate/core';
import { CardTableComponent } from './components/card-table/card-table.component';
import { TransformDataTablePipe } from './Utils/transform-data-table.pipe';
import { AmountFormatPipe } from './Utils/amount-format-pipe.pipe';
import { MatDialogService } from './services/mat-dialog.service';
import { CurrencySymbolPipe } from './Utils/currency-simbol-pipe';
import { LastFourDigitsPipe } from './Utils/lastFourDigits-pipe';
import { CustomIconColorComponent } from './components/custom-icon-color/custom-icon-color.component';
import { FormsModule } from '@angular/forms';
import { LangSelectorComponent } from './components/langSelector/langSelector.component';
import { LoaderComponent } from './components/loader/loader.component';
import { SafePipe } from './pipes/safe.pipe';
import { NoDataComponent } from './components/no-data/no-data.component';
import { TruncatePipe } from './Utils/truncate.pipe';
import { AmountInputComponent } from './components/amount-input/amount-input.component';
import { BackNavigateButtonComponent } from './components/back-navigate-button/back-navigate-button.component';
import { IpModalMobileComponent } from '../invopay/components/ip-modal-mobile/ip-modal-mobile.component';
import { MatCheckboxChange, MatCheckboxModule } from '@angular/material/checkbox';
import { IpTitleMobileComponent } from '../invopay/components/ip-title-mobile/ip-title-mobile.component';
import { IpButtonModalComponent } from '../invopay/components/ip-button-modal/ip-button-modal.component';
import { IpDateInputComponent } from '../invopay/components/ip-date-input/ip-date-input.component';
import { IpTextAreaInputComponent } from '../invopay/components/ip-text-area-input/ip-text-area-input.component';
import { IpInputComponent } from '../invopay/components/ip-input/ip-input.component';
import { IpDragScrollComponent } from '../invopay/components/ip-drag-scroll/ip-drag-scroll.component';
import { InnerLoaderComponent } from './components/inner-loader/inner-loader.component';
import { IpFiltersTableInvoicesComponent } from '../invopay/components/ip-filters-table-invoices/ip-filters-table-invoices.component';
import { IpSelectInputComponent } from '../invopay/components/ip-select-input/ip-select-input.component';
import { NgxMatSelectSearchModule } from "ngx-mat-select-search";
import { CdkFixedSizeVirtualScroll, ScrollingModule } from "@angular/cdk/scrolling";
import { FormatTimePipe } from './Utils/format-time.pipe';
import { LoaderWithChronometerComponent } from './components/loader-with-chronometer/loader-with-chronometer.component';
import { IpEmptyDataComponent } from '../invopay/components/ip-empty-data/ip-empty-data.component';
import { DateService } from './services/date.service';
import { MobileCardListComponent } from './components/mobile-card-list/mobile-card-list.component';
import { IpBrokerInputSelectComponent } from '../invopay/components/ip-broker-input-select/ip-broker-input-select.component';
import { AmountCurrencyCodePipe } from './pipes/amount-currency-code.pipe';

@NgModule({
  declarations: [
    ChartComponent,
    TableComponent,
    PaginatorComponent,
    CustomDatePipe,
    CardTableComponent,
    TransformDataTablePipe,
    AmountFormatPipe,
    CurrencySymbolPipe,
    LastFourDigitsPipe,
    CustomIconColorComponent,
    LangSelectorComponent,
    LoaderComponent,
    SafePipe,
    NoDataComponent,
    BackNavigateButtonComponent,
    TruncatePipe,
    BackNavigateButtonComponent,
    IpModalMobileComponent,
    CardTableComponent,
    IpTitleMobileComponent,
    IpButtonModalComponent,
    IpDateInputComponent,
    IpTextAreaInputComponent,
    IpInputComponent,
    IpDragScrollComponent,
    InnerLoaderComponent,
    IpFiltersTableInvoicesComponent,
    IpSelectInputComponent,
    FormatTimePipe,
    LoaderWithChronometerComponent,
    IpEmptyDataComponent,
    MobileCardListComponent,    
    IpBrokerInputSelectComponent,
    AmountCurrencyCodePipe
  ],
  imports: [
    CommonModule,
    MaterialModule,
    TranslateModule,
    AmountInputComponent,
    MatCheckboxModule,
    ReactiveFormsModule,
    NgxMatSelectSearchModule,
    CdkFixedSizeVirtualScroll,
    ScrollingModule
],
  providers: [
    TransformDataTablePipe,
    AmountFormatPipe,
    MatDialogService,
    TruncatePipe,
    CustomDatePipe,
    DateService,
    AmountCurrencyCodePipe
  ],
  exports: [
    MaterialModule,
    ChartComponent,
    TableComponent,
    PaginatorComponent,
    ReactiveFormsModule,
    CustomDatePipe,
    CardTableComponent,
    AmountFormatPipe,
    CurrencySymbolPipe,
    LastFourDigitsPipe,
    BackNavigateButtonComponent,
    CustomIconColorComponent,
    FormsModule,
    LangSelectorComponent,
    LoaderComponent,
    AmountInputComponent,
    SafePipe,
    NoDataComponent,
    TruncatePipe,
    IpModalMobileComponent,
    CardTableComponent,
    IpTitleMobileComponent,
    IpButtonModalComponent,
    IpDateInputComponent,
    IpTextAreaInputComponent,
    IpInputComponent,
    IpDragScrollComponent,
    InnerLoaderComponent,
    IpFiltersTableInvoicesComponent,
    IpSelectInputComponent,
    NgxMatSelectSearchModule,
    LoaderWithChronometerComponent,
    IpEmptyDataComponent,
    MobileCardListComponent,
    IpBrokerInputSelectComponent,
    AmountCurrencyCodePipe
  ],
})
export class SharedModule {}
